import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <ProgressBar now={n} />.
export default function ProgressBar({ now = 0, min = 0, max = 100, className = "", label }) {
  const pct = Math.max(0, Math.min(100, ((now - min) / (max - min)) * 100))
  return (
    <div className={cn("h-4 w-full overflow-hidden rounded bg-gray-200", className)}>
      <div
        role="progressbar"
        aria-valuenow={now}
        aria-valuemin={min}
        aria-valuemax={max}
        style={{ width: `${pct}%` }}
        className="flex h-full items-center justify-center bg-integria-green text-xs text-white transition-all"
      >
        {label}
      </div>
    </div>
  )
}
